<template>
	<div class="anchorageoperationsFormHeader puiformheader">
	</div>
</template>

<script>
import PuiFormHeaderMixin from 'pui9-mixins/PuiFormHeaderMixin';

export default {
	name: 'anchorageoperations-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'anchorageoperations'
		};
	},
	computed: {
	}
}
</script>
